const bestvapewholesale = {
    id: 'bestvapewholesale',
    publicSiteName: 'Best Vape Wholesale',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#c5a142',
            secondary: '#000000',
            color1: '#ac0211',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'classic',
            dark: true,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/bestvapewholesale/favicon.ico',
        logo: '/bestvapewholesale/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
}

export default bestvapewholesale